module.exports = __webpack_public_path__ + "img/btn-border-blue.89182b1.svg";